.slider_wrapper {
  align-items: center;
  display: flex;
  gap: 1rem;
  width: 100%;
}

.slider_button {
  align-items: center;
  appearance: none;
  aspect-ratio: 1 / 1;
  background: none;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  cursor: pointer;
  display: flex;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.slider_button:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.slider_button:hover {
  border-color: var(--color-grey-700);
}

.slider_button:disabled,
.slider_button:disabled:hover {
  border: none;
  cursor: not-allowed;
}

.slider_trackwrapper {
  display: flex;
  position: relative;
  width: 100%;
}

.slider_balloon {
  color: var(--color-uva-black);
  font-weight: var(--semibold);
  position: absolute;
  text-align: center;
  top: -1.8125rem;
  white-space: nowrap;
}

.slider_input {
  appearance: none;
  background: var(--color-grey-400);
  flex-grow: 1;
  height: 0.25rem;
}

.slider_input:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.slider_input:disabled {
  cursor: not-allowed;
}

.slider_input::-webkit-slider-runnable-track {
  appearance: none;
  color: var(--color-navy-600);
  cursor: pointer;
  height: 2rem;
  margin-top: -0.125rem;
}

.slider_input:disabled::-webkit-slider-runnable-track {
  cursor: not-allowed;
}

.slider_input::-webkit-slider-thumb {
  appearance: none;
  background: var(--color-uva-white);
  border: 2px solid var(--color-navy-600);
  border-radius: 0.125rem;
  cursor: pointer;
  height: var(--thumb-size);
  margin-top: calc(0.5rem + 1px);
  position: relative;
  width: var(--thumb-size);
}

.slider_input:disabled::-webkit-slider-thumb,
.slider_input:disabled:hover::-webkit-slider-thumb {
  background: var(--color-grey-700);
  border: 2px solid var(--color-grey-700);
  cursor: not-allowed;
}

.slider_input::-moz-range-thumb {
  appearance: none;
  background: var(--color-uva-white);
  border: 2px solid var(--color-navy-600);
  border-radius: 0.125rem;
  cursor: pointer;
  height: var(--thumb-size);
  margin-top: calc(-0.25rem - 1px);
  position: relative;
  width: var(--thumb-size);
}

.slider_input:disabled::-moz-range-thumb,
.slider_input:hover:disabled::-moz-range-thumb {
  background: var(--color-grey-700);
  border: 2px solid var(--color-grey-700);
  cursor: not-allowed;
}

.slider_input::-ms-thumb {
  appearance: none;
  background: var(--color-uva-white);
  border: 2px solid var(--color-navy-600);
  border-radius: 0.125rem;
  cursor: pointer;
  height: var(--thumb-size);
  margin-top: calc(-0.25rem - 1px);
  position: relative;
  width: var(--thumb-size);
}

.slider_input:disabled::-ms-thumb,
.slider_input:hover:disabled::-ms-thumb {
  background: var(--color-grey-700);
  border: 2px solid var(--color-grey-700);
  cursor: not-allowed;
}

.slider_input::-webkit-slider-thumb:hover {
  background: var(--color-navy-200);
  border: 2px solid var(--color-navy-800);
}

.slider_input::-moz-range-thumb:hover {
  background: var(--color-navy-200);
  border: 2px solid var(--color-navy-800);
}

.slider_input::-ms-thumb:hover {
  background: var(--color-navy-200);
  border: 2px solid var(--color-navy-800);
}

.slider_input::-moz-range-progress {
  background-color: var(--color-navy-600);
}

.slider_input::-moz-range-track {
  background-color: var(--color-grey-400);
}

.slider_input::-ms-fill-lower {
  background-color: var(--color-navy-600);
}

.slider_input::-ms-fill-upper {
  background-color: var(--color-grey-400);
}
